import { render, staticRenderFns } from "./CollectListDefaultLayout.vue?vue&type=template&id=0c64424e&scoped=true"
import script from "./CollectListDefaultLayout.vue?vue&type=script&lang=js"
export * from "./CollectListDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c64424e",
  null
  
)

export default component.exports